import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { InfoCircleFilled, RightOutlined } from '@ant-design/icons';
import { Typography } from '../../components';
import classNames from 'classnames';

import './Notification.scss';

const { Text, Paragraph } = Typography;

export const Notification = ({ type = 'action', title, description, link }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const classes = classNames('notification', {
        [`notification--${type}`]: type,
    });

    const handleLinkClick = (e) => {
        if (!link) return;
        // Don't navigate if already on the target page
        if (location.pathname === link.route) {
            e.preventDefault();
            navigate(location.pathname, {
                state: {
                    ...(link.routeState || {}),
                    _notificationActionAt: Date.now(),
                },
            });
        }
    };

    return (
        <div className={classes}>
            <div className="notification__icon">
                <InfoCircleFilled />
            </div>
            <div className="notification__content">
                <Text className="notification__title bold">{title}</Text>
                <Paragraph className="notification__description">{description}</Paragraph>
            </div>
            {link && (
                <Link to={link.route} state={link.routeState} onClick={handleLinkClick} className="notification__link">
                    {link.text}
                    <RightOutlined />
                </Link>
            )}
        </div>
    );
};
